<template>
  <div v-if="isAdmin" class="admin-panel">
    <h3 class="typo-headline-6">Panel de Administración</h3>
    <div v-if="loading" class="loading-stats typo-body-2">
      Cargando datos...
    </div>
    <div v-else-if="error" class="error-stats typo-body-2">
      {{ error }}
    </div>
    <div class="admin-content" v-else>
      <div class="stats-content">
        <div class="stat-item">
          <span class="stat-label">Mensajes que necesitan respuesta:</span>
          <router-link :to="{ name: 'AdminNeedResponse' }" class="stat-value stat-link">
            {{ needResponseCount }}
          </router-link>
        </div>
        <div class="stat-item">
          <span class="stat-label">Reportes pendientes:</span>
          <router-link :to="{ name: 'AdminReports' }" class="stat-value stat-link">
            {{ reportsCount }}
          </router-link>
        </div>
      </div>
      
      <button class="admin-panel-btn typo-button" @click="goToAdminPanel">
        <i class="material-icons">admin_panel_settings</i>
        Panel de Administración
      </button>
    </div>
  </div>
</template>

<script>
import forumApi from '@/services/forumApi';
const axios = forumApi;
import { mapGetters } from 'vuex';

export default {
  name: 'AdminActivityWidget',
  data() {
    return {
      loading: true,
      error: null,
      needResponseCount: 0,
      reportsCount: 0,
    };
  },
  computed: {
    ...mapGetters(['_g_IsUserLogged', '_g_User']),
    isAdmin() {
      return !!(this._g_User && this._g_User.is_admin_user);
    }
  },
  watch: {
    isAdmin(newIsAdmin, oldIsAdmin) {
      if (newIsAdmin && !oldIsAdmin) {
        this.fetchAdminData();
      } else if (!newIsAdmin) {
        this.loading = false;
        this.error = null;
        this.needResponseCount = 0;
        this.reportsCount = 0;
      }
    }
  },
  mounted() {
    if (this._g_IsUserLogged) {
      if (this.isAdmin) {
        this.fetchAdminData();
      } else {
        this.loading = false;
      }
    } else {
      this.loading = false;
    }
  },
  methods: {
    fetchAdminData() {
      this.loading = true;
      this.error = null;
      Promise.all([
        this.fetchNeedResponseCount(),
        this.fetchReportsCount()
      ]).catch(err => {
        console.error('Error fetching admin data:', err);
        this.error = 'Error al cargar datos de administración';
      }).finally(() => {
        this.loading = false;
      });
    },
    fetchNeedResponseCount() {
      return axios.get('/forum/api/need-response/get', {
        params: {
          count_only: true
        }
      })
      .then(response => {
        if (response.data && response.data.success && response.data.pagination && response.data.pagination.total) {
          const totalTopics = response.data.pagination.total.topics || 0;
          const totalComments = response.data.pagination.total.comments || 0;
          this.needResponseCount = totalTopics + totalComments;
        } else {
          //
          throw new Error('Invalid response for need response count');
        }
      })
      .catch(error => {
        console.error('Error fetching need response count:', error);
        this.error = this.error || 'Error al cargar mensajes pendientes';
        throw error;
      });
    },
    fetchReportsCount() {
      this.reportsCount = 0;
      return Promise.resolve();
    },
    goToAdminPanel() {
      this.$router.push({ name: 'AdminPanel' });
    },
    formatDate(timestamp) {
      if (!timestamp) return '';
      const date = new Date(timestamp * 1000);
      return date.toLocaleDateString('es-ES', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    }
  }
};
</script>

<style scoped>
.admin-panel {
  background-color: var(--color-surface);
  padding: 20px;
  border-radius: 15px;
  color: var(--color-text-primary);
}

.admin-panel h3 {
  margin-top: 0;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid var(--color-outline);
}

.stats-content {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.stat-item {
  display: flex;
  justify-content: space-between;
  padding: 5px 0;
}

.stat-label {
  color: var(--color-text-secondary);
}

.stat-value {
  font-weight: 500;
}

.stat-link {
  color: var(--color-highlight);
  text-decoration: none;
  transition: opacity 0.3s ease;
}

.stat-link:hover {
  opacity: 0.8;
  text-decoration: underline;
}

.admin-panel-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  background-color: var(--color-highlight);
  color: var(--color-on-highlight, white);
  border: none;
  padding: 10px;
  border-radius: 4px;
  margin-top: 15px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  width: 100%;
}

.admin-panel-btn:hover {
  background-color: var(--color-highlight-dark, #1976d2);
}

.loading-stats,
.error-stats {
  text-align: center;
  padding: 10px 0;
}

.error-stats {
  color: #f44336;
}
</style> 